// @ts-nocheck
// ----------------------------------------------------------------------

export default function Card(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.z16,
          borderRadius: theme.shape.borderRadiusMd,
          position: 'relative',
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          // Hairline enclosure so cards read like machined glass plates rather
          // than floating slabs — pairs with the diffused ambient shadow.
          border: `1px solid ${theme.palette.grey[500_8]}`,
          transition: theme.transitions.create(['box-shadow', 'transform'], {
            duration: 400,
            easing: 'cubic-bezier(0.32, 0.72, 0, 1)'
          })
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: {
          variant: 'body2',
          marginTop: theme.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3)
        }
      }
    }
  };
}